import { render, staticRenderFns } from "./ScreenMorfologica.vue?vue&type=template&id=70df5e36&scoped=true&"
import script from "./ScreenMorfologica.vue?vue&type=script&lang=js&"
export * from "./ScreenMorfologica.vue?vue&type=script&lang=js&"
import style0 from "./ScreenMorfologica.vue?vue&type=style&index=0&id=70df5e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df5e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
